import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appArabicOnly]',
  standalone: false
})
export class ArabicOnlyDirective {
  private el = inject(ElementRef);

  private arabicRegex = /^[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿\s\-']*$/;

  @HostListener('beforeinput', ['$event']) onBeforeInput(event: InputEvent): void {
    if (!event.data) return;
    if (!this.arabicRegex.test(event.data)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') || '';
    const filtered = pastedText.split('').filter(c => /[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿\s\-']/.test(c)).join('');

    if (filtered !== pastedText) {
      event.preventDefault();
      if (!filtered) return;

      const input = this.el.nativeElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const before = input.value.substring(0, start);
      const after = input.value.substring(end);

      input.value = before + filtered + after;
      const pos = start + filtered.length;
      input.setSelectionRange(pos, pos);
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }
}
